// extracted by mini-css-extract-plugin
module.exports = {"bannerComponent":"tk","red":"uk","calloutlink":"vk","headerTopBanner":"wk","bgcolorRed":"xk","headerTopCallout":"yk","searchBanner":"zk","hideMobile":"Ak"};